import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { MetodoPagoService } from '../../../services/MetodoPagoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'metodo_pago',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. PPD',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'metodo_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Ej. Pago en parcialidades o diferido',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const MetodoPagoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await MetodoPagoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await MetodoPagoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Método de Pago"
      subtitle="Métodos de pago según catálogo del SAT (PUE / PPD)"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/MetodosPago"
    />
  );
};

export default MetodoPagoForm;
